var exports = {
  "Yr": "x93eb46d8--ffdd15--branding-container",
  "m": "x93eb46d8--ffdd15--branding-avatar",
  "C$": "x93eb46d8--ffdd15--branding-content",
};

module.exports = exports;
